import type { NodePropertySchema } from '../../../types/node-properties';

const schema: NodePropertySchema = {
  nodeType: 'string',
  version: '1.0.0',
  properties: [
    {
      key: 'operation',
      label: 'Operation',
      type: 'options',
      required: true,
      default: 'uppercase',
      options: [
        { value: 'uppercase', name: 'To Uppercase' },
        { value: 'lowercase', name: 'To Lowercase' },
        { value: 'trim', name: 'Trim' },
        { value: 'replace', name: 'Find and Replace' },
        { value: 'split', name: 'Split' },
        { value: 'substring', name: 'Substring' },
        { value: 'concat', name: 'Concatenate' },
        { value: 'length', name: 'Get Length' },
      ],
      description: 'The string operation to perform',
    },

    // ===== INPUT FIELD (for most operations) =====
    {
      key: 'field',
      label: 'Input String',
      type: 'string',
      required: true,
      placeholder: '{{ $node["NodeName"].string }}',
      description: 'The string to operate on',
      displayOptions: {
        show: {
          operation: ['uppercase', 'lowercase', 'trim', 'replace', 'split', 'substring', 'length'],
        },
      },
    },

    // ===== CONCAT OPERATION =====
    {
      key: 'strings',
      label: 'Strings to Concatenate',
      type: 'fixedCollection',
      required: true,
      typeOptions: {
        multipleValues: true,
      },
      default: {
        values: [
          { value: '' },
          { value: '' },
        ],
      },
      displayOptions: {
        show: {
          operation: ['concat'],
        },
      },
      fixedCollectionOptions: [
        {
          name: 'values',
          displayName: 'String',
          values: [
            {
              key: 'value',
              label: 'Value',
              type: 'string',
              required: true,
              placeholder: '{{ $node["NodeName"].string }}',
              description: 'String value to concatenate',
            },
          ],
        },
      ],
    },
    {
      key: 'separator',
      label: 'Separator',
      type: 'string',
      default: '',
      placeholder: 'e.g., " " or ", "',
      description: 'String to insert between concatenated values',
      displayOptions: {
        show: {
          operation: ['concat'],
        },
      },
    },

    // ===== REPLACE OPERATION =====
    {
      key: 'searchValue',
      label: 'Search For',
      type: 'string',
      required: true,
      placeholder: 'text to find',
      description: 'The string to search for',
      displayOptions: {
        show: {
          operation: ['replace'],
        },
      },
    },
    {
      key: 'replaceValue',
      label: 'Replace With',
      type: 'string',
      default: '',
      placeholder: 'replacement text',
      description: 'The string to replace matches with',
      displayOptions: {
        show: {
          operation: ['replace'],
        },
      },
    },

    // ===== SPLIT OPERATION =====
    {
      key: 'separator',
      label: 'Separator',
      type: 'string',
      default: ',',
      placeholder: 'e.g., "," or " "',
      description: 'The delimiter to split by',
      displayOptions: {
        show: {
          operation: ['split'],
        },
      },
    },

    // ===== SUBSTRING OPERATION =====
    {
      key: 'start',
      label: 'Start Position',
      type: 'number',
      default: 0,
      typeOptions: {
        minValue: 0,
      },
      description: 'Starting index (0-based)',
      displayOptions: {
        show: {
          operation: ['substring'],
        },
      },
    },
    {
      key: 'length',
      label: 'Length',
      type: 'number',
      placeholder: 'Leave empty for rest of string',
      description: 'Number of characters to extract (optional)',
      displayOptions: {
        show: {
          operation: ['substring'],
        },
      },
    },
  ],
};

export default schema;
